import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { UiPlatformTabsComponent } from './tabs.component';

@NgModule({
  declarations: [UiPlatformTabsComponent],
  imports: [
    CommonModule,
    NzTabsModule
  ],
  exports: [UiPlatformTabsComponent]
})
export class UiPlatformTabsModule {}
